import Vue from 'vue'
import { format } from 'date-fns'

Vue.prototype.$invoiceTools = {
  prepareResult (data, varData, logPrefix) {
    if (typeof logPrefix !== 'undefined') {
      // console.log(logPrefix + ':API:Response: ', JSON.stringify(data))
    }
    let $data = {}
    if (data) {
      if (data.status === true) {
        if (Array.isArray(varData)) {
          varData.forEach(v => {
            $data[v] = data[v]
          })
        } else {
          $data = data[varData] ? data[varData] : ''
        }
        const ret = {
          success: true,
          data: $data
        }
        if (typeof logPrefix !== 'undefined') {
          // console.log(logPrefix + ':PreparedData: ', ret)
        }
        return ret
      } else if (data.status === false && data.message) {
        return {
          success: false,
          data: data.message
        }
      }
    }

    return {
      success: false,
      data: '<b>レスポンス: </b>' + data
    }
  },
  formatDate (date, b = 0) {
    if (!date) return ''
    if (date.indexOf('-') > 0) {
      const x = /-/gi
      return date.replace(x, '/')
    } else {
      if (b) return date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2)
      else if (date.indexOf('/') > 0) return date
      else return date.substr(0, 4) + '/' + date.substr(4, 2) + '/' + date.substr(6, 2)
    }
  },
  formatDateHours (date) {
    if (!date) return ''
    return format(new Date(date), 'yyyy/MM/dd HH:mm')
  },
  formatDateTime (date) {
    if (!date) return ''
    return format(new Date(date), 'yyyy/MM/dd')
  },
  formatDateAt (date, b = 0) {
    if (!date) return '-----------'
    if (date === '-----------') return date
    if (date.indexOf('-') > 0) {
      const x = /-/gi
      return date.replace(x, '/')
    } else {
      if (b) return date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2)
      else if (date.indexOf('/') > 0) return date
      else return date.substr(0, 4) + '/' + date.substr(4, 2) + '/' + date.substr(6, 2)
    }
  },
  getCurrentDate () {
    let date = new Date()
    let currentDate = '' + date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-' + ((date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate())
    return currentDate
  },
  getObjPropsById (obj, id, output) {
    let ret = ''
    obj.forEach((val, i) => {
      if (val.id === id) {
        ret = val[output]
      }
    })
    return ret
  },
  setObjProps (obj, id, key, val) {
    this.log('setObjProps: ', obj)
    obj.forEach((v, i) => {
      if (v.id === id) {
        v[key] = val
      }
    })
    return obj
  },
  log (txt, printData) {
    console.log(txt, printData)
  },
  getObjPropsByKey (obj, key, val, output) {
    let ret = ''
    obj.forEach((v, i) => {
      this.log('getObjPropsByKey: ', [v[key], (v[key] === val)])

      if (v[key] === val) {
        ret = v[output]
      }
    })
    return ret
  },

  parseTxtNum (num) {
    return Number(num).toLocaleString()
  },
  parseTxtNumToFixed (num) {
    return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2 })
  },

  /**
   * convert base64 to ArrayBuffer response type
   * @param base64 : sting
   * @returns ArrayBuffer
   */
  __b64ToArrayBuffer (base64) {
    let binaryString = window.atob(base64)
    let len = binaryString.length
    let bytes = new Uint8Array(len)
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    return bytes.buffer
  },

  isInArrayObj (obj, key, val) {
    let ret = false
    obj.forEach((d, i) => {
      if (d[key] === val) {
        ret = true
      }
    })
    return ret
  },

  moneyDelimiter (val) {
    var valAry
    valAry = String(val).split('.')
    valAry[0] = valAry[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    return valAry.join('.')
  },

  getCurrentFormatDate () {
    let date = new Date()
    let currentDate = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-' + ((date.getDate() < 10) ? ('0' + date.getDate()) : date.getDate())

    return currentDate
  },

  toComma (obj) { // カンマ編集を行う
    if ((obj.value).trim().length !== 0 && !isNaN(obj.value)) {
      obj.value = Number(obj.value).toLocaleString()
    }
  },
  offComma (obj) { // カンマ編集を解除する
    var reg = new RegExp(',', 'g')
    var chgVal = obj.value.replace(reg, '')
    if (!isNaN(chgVal)) {
      obj.value = chgVal
      obj.select()
    }
  }

}
